import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import FAQs from './pages/FAQs';
import About from './pages/About';
import Testimonials from './pages/Testimonials';
import LeadGeneration from './pages/services/LeadGeneration';
import CustomerRetention from './pages/services/CustomerRetention';
import WebsiteCreation from './pages/services/WebsiteCreation';
import CustomSolutions from './pages/services/CustomSolutions';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Security from './pages/Security';
import Blog from './pages/Blog';
import Documentation from './pages/Documentation';
import HelpCenter from './pages/HelpCenter';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/services/lead-generation" element={<LeadGeneration />} />
          <Route path="/services/customer-retention" element={<CustomerRetention />} />
          <Route path="/services/website-creation" element={<WebsiteCreation />} />
          <Route path="/services/custom-solutions" element={<CustomSolutions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/security" element={<Security />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;